import { ComplaintClient } from './complaint-client.model';
import { ComplaintClientRepresentative } from './complaint-client-representative.model';
import { ComplaintAddress } from './complaint-address.model';
import { ComplaintSimpleAddress } from './complaint-simple-address.model';
import { ComplaintBill } from './complaint-bill.model';
import { Email } from 'src/app/core/models/email.model';
import { EmailNotification } from './complaint-email-notification.model';
import { ComplaintConcept } from './complaint-concept.model';

/**Reclamo */
export class Complaint {
    public indicadorTitular:string;
    /**Código de sub motivo */
    public subReasonCode: string;
    /**Descripción de reclamo */
    public description: string;
    /**Solicitar contrastación de medidor? */
    public requestMeterContrast: boolean;
    /**Cliente */
    public client: ComplaintClient;
    /**Datos de representante de cliente */
    public clientRepresentative: ComplaintClientRepresentative;
    /**Dirección de cliente */
    public clientAddress: ComplaintAddress;
    /**Primera dirección de notificación */
    public firstNotificationAddress: string;
    /**Segunda dirección de notificación */
    public secondNotificationAddress: ComplaintSimpleAddress;
    /**Email de notificación */
    public emailAddressNotification:EmailNotification;
    /**Recibo */
    public billList: ComplaintBill[];
    /**Datos de correo */
    public email: Email;

    public isAcceptTerms: boolean;

    /* Bloquei de reclamos*/
    public ComplaintConcepto:ComplaintConcept[];
}